import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/index'
import ElementUI from 'element-ui';
import axios from 'axios'
import cookies from 'js-cookie'
import md5 from 'js-md5';
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import 'element-ui/lib/theme-chalk/index.css';
import './styles/index.scss'
Vue.use(router)
Vue.use(ElementUI)
Vue.prototype.axios = axios;
Vue.prototype.$cookies = cookies;
Vue.prototype.$md5 = md5;
Vue.prototype.$dayjs = dayjs;
dayjs.extend(duration)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
